import { Component, OnInit} from '@angular/core';
import { HTTPStatus } from './CommonService/app-token-handler';
import {ChangeDetectorRef} from '@angular/core'
import { template } from '@angular-devkit/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  template:  '<app-menu></app-menu>'
})
  export class AppComponent implements OnInit {
    iSLoading!: boolean;

  constructor(private httpStatus: HTTPStatus,private cdref: ChangeDetectorRef) {

    this.httpStatus.getHttpStatus().subscribe((status: boolean) => { this.iSLoading = status; });
  }

  ngOnInit() {
}

// ngAfterViewChecked()
ngAfterContentChecked(){

  this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
              this.iSLoading = status;
              this.cdref.detectChanges();
  });
}
}
